import { IAuth } from "../auth/auth";
import { Axios } from "../axios";
import ReviewPageProps from "./reviewPage";

export const initializeTransaction = async (body: ReviewPageProps.InitializeTransactionProps) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  const vendorUserKey = localStorage.getItem("vendorUserKey") || "";
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post(`/remit/user/${vendorUserKey}/initializeTransaction`, body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const getTransactionSummary = async (body: any) => {
  const currentUser = JSON.parse(localStorage.getItem("currentUser") || "{}");
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.post("/remit/user/getTransactionSummary", body, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};

export const veryifyDualTrxn = async (
  currentUser: IAuth.IIsAuthorisedProps,
  dualNumber: string,
) => {
  const vendorUserDetails = JSON.parse(localStorage.getItem("vendorUserDetails") || "{}");
  const userRecipientId = localStorage.getItem("recipient_id") || "";

  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(
      `/remit/user/${currentUser.vendor_key}/${vendorUserDetails.id}/verifyForDualTrnx/${dualNumber}/${userRecipientId}`,
      {
        headers: {
          Authorization: `${currentUser.idToken}`,
        },
      },
    );
  }
};

export const getVendorCodes = async (currentUser: IAuth.IIsAuthorisedProps) => {
  if (currentUser !== null && currentUser !== undefined) {
    return await Axios.get(`/remit/user/vendorCode`, {
      headers: {
        Authorization: `${currentUser.idToken}`,
      },
    });
  }
};
